// The line above disables needing a default export when there's only one constant to export.
// Can be removed when multiple constants are defined.

export const SMS_REDIRECT_STATUS = 'smsredirect';
export const FR_SESSION_TYPE = 'fr';
